import { render, staticRenderFns } from "./sign-type.vue?vue&type=template&id=9353d882&scoped=true"
import script from "./sign-type.vue?vue&type=script&lang=js"
export * from "./sign-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9353d882",
  null
  
)

export default component.exports